import {
	throttle,
} from "../utils/functionExecutionThrottle";

function initHeaderScrollAnimation(): void {
	const stickyHeaderDiv =
		document.querySelector( "header>#sticky-header" ) as HTMLElement;

	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	if ( prefersReducedMotion ) {
		stickyHeaderDiv.style.display = "none";
		stickyHeaderDiv.setAttribute( "aria-hidden", "" );
		stickyHeaderDiv.setAttribute( "inert", "" );
		return;
	}

	const animationDuration = 200;
	let lastScrollY = 0;
	let currentScroll = window.scrollY;
	let headerHeight: number;
	let resizeTimestamp = 0;
	const throttleTime = 50;


	function updateHeaderHeight(): void {
		const header = document.querySelector( "header" ) as HTMLElement;
		const height = header?.getBoundingClientRect()?.height ?? 0;
		headerHeight = height;
	}

	updateHeaderHeight();

	if ( stickyHeaderDiv && currentScroll < headerHeight ) {
		stickyHeaderDiv.setAttribute( "aria-hidden", "" );
		stickyHeaderDiv.setAttribute( "inert", "" );
		stickyHeaderDiv.classList.add( "hidden" );
		stickyHeaderDiv.classList.remove( "fixed" );
		stickyHeaderDiv.style.transform = `translateY( -${headerHeight}px )`;
	}

	window.addEventListener( "scroll", ( ) => {
		currentScroll = window.scrollY;

		if ( Date.now( ) - resizeTimestamp < throttleTime ) {
			return;
		}

		if ( currentScroll > headerHeight && lastScrollY > currentScroll ) {
			stickyHeaderDiv.classList.remove( "hidden" );
			stickyHeaderDiv.classList.add( "fixed" );

			stickyHeaderDiv?.animate( [
				{
					transform: "translateY( 0px )",
				},
			], {
				duration: animationDuration,
				fill: "forwards",
			} ).finished.then( ( ) => {
				stickyHeaderDiv.removeAttribute( "aria-hidden" );
				stickyHeaderDiv.removeAttribute( "inert" );
			} );
		} else if ( lastScrollY < currentScroll || currentScroll < headerHeight ) {
			stickyHeaderDiv?.animate( [
				{
					transform: `translateY( -${headerHeight}px )`,
				},
			], {
				duration: animationDuration,
				fill: "forwards",
			} ).finished.then( ( ) => {
				stickyHeaderDiv.setAttribute( "aria-hidden", "" );
				stickyHeaderDiv.setAttribute( "inert", "" );
				stickyHeaderDiv.classList.add( "hidden" );
				stickyHeaderDiv.classList.remove( "fixed" );
			} );
		}

		lastScrollY = currentScroll;
	} );

	window.addEventListener( "resize", throttle( ( ) => {
		resizeTimestamp = Date.now();
		updateHeaderHeight();
	}, throttleTime ) );
}

initHeaderScrollAnimation();
